import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Packages from './Packages';

const PackagesRoutes = () => {
    return (
        <Routes>
            <Route path='/' element={<Packages />} />
        </Routes>
    );
};

export default PackagesRoutes;
